import {
  NotificationBO,
  NotificationsPageBO,
} from "@/api/graphql/notifications/types.ts";
import {
  GetNotificationsByAccountQueryQuery,
  GetNotificationsByUserQueryQuery,
} from "@/api/graphql/types/graphql.ts";

type NotificationQueryResultForUser = NonNullable<
  GetNotificationsByUserQueryQuery["NotificationsMsSearchNotifications"]["data"]
>[number];

type NotificationQueryResultForAccount = NonNullable<
  GetNotificationsByAccountQueryQuery["NotificationsMsSearchNotifications"]["data"]
>[number];

const mapNotificationFromGraphQLForUser = (
  rawNotification: NotificationQueryResultForUser,
): NotificationBO => ({
  id: rawNotification.id,
  subject: rawNotification.subject,
  hasAttachments: rawNotification.hasAttachments,
  createdTs: rawNotification.createdTs,
  accountNumber: rawNotification.AccountIdData?.number,
  accountName: rawNotification.AccountIdData?.name,
  status: rawNotification.status,
  failedReason: rawNotification.failedReason,
});

const mapNotificationFromGraphQLForAccount = (
  rawNotification: NotificationQueryResultForAccount,
): NotificationBO => ({
  id: rawNotification.id,
  subject: rawNotification.subject,
  hasAttachments: rawNotification.hasAttachments,
  createdTs: rawNotification.createdTs,
  firstName: rawNotification.UserIdData?.firstName,
  lastName: rawNotification.UserIdData?.lastName,
  email: rawNotification.UserIdData?.email,
  status: rawNotification.status,
  failedReason: rawNotification.failedReason,
});

export const mapNotificationsFromUserGraphQL = (
  rawNotifications: NotificationQueryResultForUser[] | undefined,
): NotificationBO[] =>
  rawNotifications?.map(mapNotificationFromGraphQLForUser) ?? [];

export const mapNotificationsFromAccountGraphQL = (
  rawNotifications: NotificationQueryResultForAccount[] | undefined,
): NotificationBO[] =>
  rawNotifications?.map(mapNotificationFromGraphQLForAccount) ?? [];

export const mapNotificationsPageFromGraphQLForUser = (
  rawPage:
    | GetNotificationsByUserQueryQuery["NotificationsMsSearchNotifications"]
    | null
    | undefined,
): NotificationsPageBO | undefined => {
  if (!rawPage) {
    return;
  }

  return {
    data: mapNotificationsFromUserGraphQL(rawPage.data ?? []),
    pagination: {
      page: rawPage.pagination.page,
      size: rawPage.pagination.size,
      total: rawPage.pagination.total,
    },
  };
};

export const mapNotificationsPageFromGraphQLForAccount = (
  rawPage:
    | GetNotificationsByAccountQueryQuery["NotificationsMsSearchNotifications"]
    | null
    | undefined,
): NotificationsPageBO | undefined => {
  if (!rawPage) {
    return;
  }

  return {
    data: mapNotificationsFromAccountGraphQL(rawPage.data ?? []),
    pagination: {
      page: rawPage.pagination.page,
      size: rawPage.pagination.size,
      total: rawPage.pagination.total,
    },
  };
};
